import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 mb-5" }

import {Bar} from 'vue-chartjs'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'
import {computed} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {dateFormatter} from "@/utils/helper";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportChartDataComponent',
  setup(__props) {

const route = useRoute()

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
const store = useStore()

const reportData = computed(() => store.state.restoReport.data)

const chartData = computed(() => {

  const dateData: { dataDate: string; total: any; }[] = []
  const dateLabel = []

  let data: any[] = []

  reportData.value.forEach((v: any) => {
    const dataDate = dateFormatter(v.created_at)
    const findData = dateData.find((val) => {
      return val.dataDate === dataDate
    })

    if (!findData) {
      dateData.push({dataDate, total: v.amount})
    } else {
      findData.total += v.amount
    }
  })

  let {startDate, endDate} = route.query
  if (!startDate && !endDate) {
    startDate = endDate = dateFormatter(moment())
  }
  let diffDate = moment(endDate).diff(moment(startDate), 'days')
  if (!diffDate) {
    diffDate = 1
  }
  for (let i = 0; i < diffDate; i++) {
    dateLabel.push(dateFormatter(moment(startDate).add(i, 'days')))
  }

  dateLabel.forEach((v) => {
    const find = dateData.find((val) => {
      return val.dataDate === v
    })
    data.push(find ? find.total : 0)
  })

  return {
    labels: dateLabel,
    datasets: [
      {
        label: 'Daily Sales',
        backgroundColor: '#f87979',
        data: data
      }
    ]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Bar), {
      "chart-otions": chartOptions,
      "chart-data": _unref(chartData),
      chartId: "bar-chart",
      width: "100%",
      height: "350"
    }, null, 8, ["chart-data"])
  ]))
}
}

})